/**
 * @description Renders the user menu icon and menu displayed on the application navigation bar
 */

import React from 'react';
import Popover from '@mui/material/Popover';

import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';

import { NavUserIcon } from './NavUserIcon';
import NavUserMenuHeader from './NavUserMenuHeader';
import NavUserMenuLinks from './NavUserMenuLinks';
import { UserSettingsContext } from '../contexts/userSettings';

const styles = {
  popover: {
    border: 1,
    borderColor: 'grey.400',
    boxSizing: 'content-box',
    maxWidth: '18.75rem',
    overflow: 'hidden',
    width: '18.75rem'
  }
};

const NavUserMenu = () => {
  // Maintains a pointer to the menu anchor
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Retrieve the user settings
  const userSettings = React.useContext(UserSettingsContext);

  /**
   * Handles menu click events by saving the menu anchor target (which in turn will open the menu)
   * @param {ClickEvent} evt - menu click event
   */
  function handleClick (evt) {
    setAnchorEl(evt.currentTarget);
  }

  /**
   * Handles menu close events by clearing the menu anchor target (which in turn will close the menu)
   */
  function handleClose () {
    setAnchorEl(null);
  }

  // Parse the first and last name to get the initials to display in the user icon
  const initials = userSettings ? `${ userSettings.firstName?.[0] ?? '' }${ userSettings.lastName?.[0] ?? '' }` : '';

  return (
    <>
      <NavUserIcon onClick={(evt) => handleClick(evt)}>
        {initials}
      </NavUserIcon>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom'
        }}
        id='menu-appbar-usermenu'
        onClose={() => handleClose()}
        open={Boolean(anchorEl)}
        PaperProps={{ sx: styles.popover }}
        transformOrigin={{
          horizontal: 'right',
          vertical: -5
        }}
      >
        <ErrorBoundary>
          <NavUserMenuHeader initials={initials} />
        </ErrorBoundary>
        <ErrorBoundary>
          <NavUserMenuLinks onSelection={() => handleClose()} />
        </ErrorBoundary>
      </Popover>
    </>
  );
};

export default NavUserMenu;
